// @todo create a service in vue-shared-components repository
import store from '../store';

export const isActionAllowed = (
  rights,
  controller,
  action,
  index = '*',
  collection = '*'
) => {
  if (!rights || typeof rights !== 'object') {
    throw new Error(
      'rights parameter is mandatory for isActionAllowed function'
    );
  }
  if (!controller || typeof controller !== 'string') {
    throw new Error(
      'controller parameter is mandatory for isActionAllowed function'
    );
  }
  if (!action || typeof action !== 'string') {
    throw new Error(
      'action parameter is mandatory for isActionAllowed function'
    );
  }

  // We filter in all the rights that match the request (including wildcards).
  const filteredRights = rights
    .filter(function (right) {
      return right.controller === controller || right.controller === '*';
    })
    .filter(function (right) {
      return right.action === action || right.action === '*';
    })
    .filter(function (right) {
      return right.index === index || right.index === '*';
    })
    .filter(function (right) {
      return right.collection === collection || right.collection === '*';
    });

  if (
    filteredRights.some(function (item) {
      return item.value === 'allowed';
    })
  ) {
    return true;
  }
  return false;
};

export const canGetAssetsMapping = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'collection',
    'getMapping',
    store.getters['tenants/selectedTenant']._id,
    'assets'
  );

export const canSearchDevices = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'device-manager/device',
    'search',
    store.getters['tenants/selectedTenant']._id
  );

export const canGetAsset = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'document',
    'get',
    store.getters['tenants/selectedTenant']._id,
    'assets'
  );

export const canSearchAssetHistory = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'document',
    'search',
    store.getters['tenants/selectedTenant']._id,
    'asset-measures-history'
  );

export const canMLinkDevices = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'device-manager/device',
    'mLink',
    store.getters['tenants/selectedTenant']._id
  );

export const canUnlinkDevice = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'device-manager/device',
    'unlink',
    store.getters['tenants/selectedTenant']._id
  );

export const canUpdateAsset = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'document',
    'update',
    store.getters['tenants/selectedTenant']._id,
    'assets'
  );

export const canGetDeviceMapping = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'collection',
    'getMapping',
    store.getters['tenants/selectedTenant']._id,
    'devices'
  );

export const canSearchAsset = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'device-manager/device',
    'search',
    store.getters['tenants/selectedTenant']._id
  );

export const canGetDevice = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'document',
    'get',
    store.getters['tenants/selectedTenant']._id,
    'devices'
  );

export const canSearchDeviceHistory = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'document',
    'search',
    store.getters['tenants/selectedTenant']._id,
    'asset-measures-history'
  );

export const canMLinkAsset = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'device-manager/device',
    'mLink',
    store.getters['tenants/selectedTenant']._id
  );

export const canUnlinkAsset = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'device-manager/device',
    'unlink',
    store.getters['tenants/selectedTenant']._id
  );

export const canUpdateDevice = () =>
  isActionAllowed(
    store.getters['auth/currentUserRights'],
    'document',
    'update',
    store.getters['tenants/selectedTenant']._id,
    'devices'
  );
